import React from "react";
import { Route } from "react-router-dom";
import VerifierDashboard from "../../screens/verifier/VerifierDashboard";

export const verifierRoutes = [
  <Route key="verifier-dashboard" path="/" element={<VerifierDashboard />} />,
];
